<template>
  <div>
    <v-container class="ml-10">
      <p class="display-1 mt-7">결제 관리</p>
      <p class="mb-0 subtitle-1 font-weight-light">정품 인증 서비스 결제 및 내역 확인을 할 수 있습니다.</p>
      <p class="mb-0 subtitle-1 font-weight-light">사용 기간을 선택하여 결제가 가능합니다.</p>
      <p
        class="mb-0 subtitle-1 font-weight-light"
        style="color:#2196F3"
      >(사용 기간별 할인 혜택을 참고하세요 - 3개월 5% / 6개월 7% / 12개월 10% 할인)</p>
      <Payment></Payment>
      <PaymentList></PaymentList>
    </v-container>
  </div>
</template>

<script>
import Payment from "@/components/shoplus_authservice/payment/Payment.vue";
import PaymentList from "@/components/shoplus_authservice/payment/PaymentList.vue";

export default {
  components: {
    Payment,
    PaymentList
  }
};
</script>
